import { createContext, useContext, useEffect } from "react";

export interface ThemeContextValue {
  isDark: boolean;
  toggleTheme: () => void;
  setForceLightMode: (force: boolean) => void;
}

export const ThemeContext = createContext<ThemeContextValue>({
  isDark: false,
  toggleTheme: () => {},
  setForceLightMode: () => {},
});

export function useTheme() {
  return useContext(ThemeContext);
}

/** Forces light mode while the calling component is mounted. */
export function useForceLightMode() {
  const { setForceLightMode } = useContext(ThemeContext);
  useEffect(() => {
    setForceLightMode(true);
    return () => setForceLightMode(false);
  }, [setForceLightMode]);
}
